module.exports = __webpack_public_path__ + "media/images/icons/feedback-f965250a75d6d8079537d86e2eee7371.svg";